<app-mixit-x509-banner/>
@if (alarm$ | async) {
  <app-alarm-bar [alarm]="alarm$"> </app-alarm-bar>
}

<app-schematics-tile
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [showShadow]="false"
  [dataPoints$]="dataPoints$">
</app-schematics-tile>

@if (pumpDevice$ | async) {
  <app-pump-status-tile
    [application]="application"
    [installation$]="installation$"
    [pumpType$]="pumpType$"
    [pumpDevice$]="pumpDevice$"
    [pumpOptions]="pumpOptions$ | async">
  </app-pump-status-tile>
}

@if (valveDevice$ | async) {
  <app-valve-status-tile
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id"
    [dataPoints$]="dataPoints$"
    [valveDevice$]="valveDevice$"
    [energyValve]="hasEnergyValve$ | async">
  </app-valve-status-tile>
}

<app-forward-return-chart-tile
  [title]="'two-stroke-heat-exchanger-dashboard.secondary-chart-title' | translate"
  [applicationId]="application.id"
  forwardDumbledoreId="T_SF"
  returnDumbledoreId="T_SR"
  [dataPoints$]="dataPoints$"
  [userTrackingPeriodOptions]="{ category: 'application/twoStrokeHeatExchanger', intervalPrefix: 'secondaryTemperature' }">
</app-forward-return-chart-tile>

<app-valve-chart
  [dataPoints$]="dataPoints$"
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [hasEnergyValve]="hasEnergyValve$ | async"
  [userTrackingPeriodOptions]="{ category: 'application/twoStrokeHeatExchanger', intervalPrefix: 'valvePosition' }">
</app-valve-chart>

@if (hasEnergyValve$ | async) {
  <app-energy-valve-heat-and-flow-chart
    [dataPoints$]="dataPoints$"
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id">
  </app-energy-valve-heat-and-flow-chart>
}

@if (hasEnergyValve$ | async) {
  <app-energy-valve-temperature-chart
    [dataPoints$]="dataPoints$"
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id">
  </app-energy-valve-temperature-chart>
}
